<template>
  <span/>
</template>

<script lang="ts">
import {Pipeline} from "@/interfaces";
import {useFavicon} from '@vueuse/core'

// see https://vueuse.org/core/useFavicon/
const icon = useFavicon()

import {defineComponent} from 'vue';

export default defineComponent({
  name: 'FavIcon',
  props: {
    pipelines: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({
    src: require('../assets/favicon.png'),
  }),
  mounted() {
    icon.value = this.src
  },
  watch: {
    pipelines: function (pipelines: Pipeline[]) {
      if (pipelines.length == 0) {
        return
      }

      const status = {
        failed: 0,
        running: 0,
      }

      for (const pipeline of pipelines) {
        const details = pipeline.details;

        switch (details.status) {
          case "failed":
            status.failed++;
            break;
          case "running":
            status.running++;
            break;
        }
      }

      const img = document.createElement('img') as HTMLImageElement
      img.src = icon.value

      const showNoIndicator = (status.failed + status.running) === 0
      if (showNoIndicator) {
        icon.value = this.src
        return
      }

      const faviconSize = 256
      img.onload = () => {
        const colors = {
          fail: '#FF0000',
          active: '#0040ff',
        }
        const count = status.failed > 0 ? status.failed : status.running
        const color = status.failed > 0 ? colors.fail : colors.active

        const canvas = document.createElement('canvas') as HTMLCanvasElement
        canvas.width = faviconSize
        canvas.height = faviconSize

        const context = canvas.getContext('2d') as CanvasRenderingContext2D
        // Draw Original Favicon as Background
        context.drawImage(img, 0, 0, faviconSize, faviconSize)

        // Draw Notification Circle
        context.beginPath()
        context.arc(canvas.width - faviconSize / 3, faviconSize / 3, faviconSize / 3, 0, 2 * Math.PI)
        context.fillStyle = color
        context.fill()

        // Draw Notification Number
        context.font = (faviconSize / 16) + 'em "helvetica", sans-serif'
        context.textAlign = 'center'
        context.textBaseline = 'middle'
        context.fillStyle = '#FFFFFF'
        context.fillText(count + "", canvas.width - faviconSize / 3, faviconSize / 3)

        // Replace favicon
        icon.value = canvas.toDataURL('image/png')
      }
    }
    ,
  },
})

</script>

<style scoped></style>
